<template>
  <div>
    <el-dialog custom-class="customDialog" :title="$t('Hadisənin_qiymətləndirilməsi')" :close-on-press-escape="false"
      :show-close="false" :close-on-click-modal="false" :visible.sync="showModal" width="40%" top="4vh" append-to-body
      @open="opened()">

      <el-form ref="assessments" :model="item" label-width="160px" :label-position="labelPosition" size="small"
        :rules="rules" v-loading="loading">
        <hr width="100%" size="50" style=" margin-top: 0;position: relative;height: 1px;background: #F3EFE0;"
          align="center">


        <div class="row">
          <div class="col-md-12 col-12">
            <el-form-item prop="status" v-if="mode == 'New'" :label="$t('Status')">
              <el-select style="width: 100%" :placeholder="$t('Seçin')" size="small" v-model="item.status">

                <el-option :label="$t('Müştəriyə_məbləğ_təklif_olunsun')" :value="1"
                  v-if="hasRoles(['Tech expertise operator', 'Tech expertise manager'])"></el-option>

                <el-option :label="$t('Müştəri_təklifi_dəyərləndirir')" :value="3"
                  v-if="hasRoles(['Tech expertise operator', 'Call center operator', 'Client service operator', 'Tech expertise manager'])"></el-option>

                <el-option :label="$t('Məbləğ_ilə_razı_deyil')" :value="8"
                  v-if="hasRoles(['Tech expertise operator', 'Call center operator', 'Client service operator', 'Tech expertise manager'])"></el-option>

                <el-option :label="$t('Məbləğ_ilə_razılaşdırıldı')" :value="4"
                  v-if="hasRoles(['Tech expertise operator', 'Call center operator', 'Client service operator', 'Tech expertise manager'])"></el-option>

                <el-option :label="$t('Təmir')" :value="2"
                  v-if="hasRoles(['Tech expertise operator', 'Call center operator'])"></el-option>

                <el-option :label="$t('Təmirə_göndərilsin')" :value="5"
                  v-if="hasRoles(['Client service operator'])"></el-option>

                <el-option :label="$t('Təmirə_təsdiq')" :value="6" v-if="hasRoles(['Tech expertise manager'])"></el-option>

                <el-option :label="$t('Müstəqil_ekspertə_göndərilsin')" :value="7"
                  v-if="hasRoles(['Tech expertise operator', 'Call center operator', 'Client service operator', 'Tech expertise manager'])"></el-option>

              </el-select>
            </el-form-item>


            <!-- 
            <el-form-item v-if="item.status === 8" :label="$t('Məbləğ_aralığı')">
              <div style="display: flex; align-items: center;">
                <el-input v-model="item.amountFrom" style="flex: 1;"></el-input>
                <span style="margin: 0 8px;">-</span>
                <el-input v-model="item.amountTo" style="flex: 1;"></el-input>
              </div>
            </el-form-item> -->

            <el-form-item v-if="item.status === 1" prop="offeredAmount" :label="$t('Təklif_olunacaq_məbləğ')">
              <el-input v-model="item.offeredAmount"></el-input>
            </el-form-item>

            <el-form-item v-if="item.status === 4" prop="agreedAmount" :label="$t('Razılaşdırılmış_məbləğ')">
              <el-input v-model="item.agreedAmount"></el-input>
            </el-form-item>


          </div>
          <div class="col-md-12 col-12">
            <el-form-item :label="$t('Qeyd')" prop="departureNote">
              <el-input type="textarea" :rows="3" v-model="item.note"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="clickSave">{{$t('Qeydə_al')}}</el-button>
        <el-button size="small" @click="clickReject">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  import { mask } from "vue-the-mask";

  import {
    CreateAssessment,
    UpdateAssessment,
    GetDamageAssessment,
    AssessmentMail,
  } from "src/services/claim";

  import { DateTimeToJson, DateToString, DateTimeToString, DateTimeReverseToString, labelPosition } from "../../services/helper";

  import { AssessmentType } from "../../services/types";

  import DateTimePicker from "./DateTimePicker.vue";

  export default {
    directives: {
      mask,
    },
    components: {
    },
    computed: {

    },
    data() {

      return {

        showModal: false,

        item: {},
        loading: false,
        mode: "",
        uid: this.$store.state.user.id,
        roles: this.$store.state.user.roles,
        labelPosition: labelPosition,
        rules: {
          // driver: [
          //   {
          //     required: true,
          //     message: this.$t('Sütun_mütləqdir'),
          //     trigger: "change",
          //   },
          // ],
        },
        // optCall: {
        //   disabledDate: (date) => {
        //     return new Date() <= date;
        //   },
        // },
      };
    },
    methods: {

      hasRoles(requiredRoles) {
        return requiredRoles.some(role => this.roles.includes(role));
      },
      clickReject() {
        this.showModal = false;
        this.loading = false;
      },
      closeDialog() {
      },

      new(claimId) {
        this.showModal = true;
        this.item = new AssessmentType();
        this.item.claimId = claimId

        this.mode = "New";
      },
      edit(id) {
        this.loading = true;
        this.mode = "Edit";
        this.showModal = true;
        GetDamageAssessment(id).then((response) => {
          this.loading = false;
          if (response.data) {
            this.item = response.data;

          } else {
            this.showModal = false;
            this.$message({
              type: "warning",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        });
      },

      clickSave() {
        this.$refs["assessments"].validate((valid) => {
          if (!valid) {
            this.$message({
              type: "warning",
              message: this.$t('Məlumatların_tam_və_düzgün_olmasını_yoxlayın'),
            });
            return false;
          } else {
            this.save();
          }
        });
      },

      opened() {
        this.resetForm();
      },
      resetForm() {
        this.$nextTick(() => {
          this.$refs["assessments"].resetFields();
        })
      },
      save() {
        this.loading = true;
        let ass = Object.assign({}, this.item);
        ass.commandUserId = this.uid;
        if (this.mode === "New") {
          CreateAssessment(ass).then((response) => {
            this.loading = false;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {
                this.$emit("saved", { action: "new", id: response.data.value });
                this.showModal = false;
                this.$message({
                  type: "success",
                  message: this.$t('Uğurlu_əməliyyat'),
                });
                let nAss = { ClaimId: ass.claimId, Status: ass.status, MailType: 1 }

                // AssessmentMail(nAss)
                //   .then(response => {
                //   })
                //   .catch(error => {
                //   });
                // if (this.roles && this.roles.includes("Call center operator")) {
                //   this.$router.push({
                //     path: "/callcenter/appraisal"

                //   });
                //   return;
                // }
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });
        } else {
          UpdateAssessment(ass).then((response) => {
            this.loading = false;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0]
                    ? response.data.errors[0]
                    : this.$t('Səhv_əməliyyat'),
                });
              } else {
                this.$emit("saved", { action: "edit", id: response.data.value });
                this.showModal = false;
                this.$message({
                  type: "success",
                  message: this.$t('Uğurlu_əməliyyat'),
                });
                let nAss = { ClaimId: ass.claimId, Status: ass.status, MailType: 2 }

                // AssessmentMail(nAss)
                //   .then(response => {
                //   })
                //   .catch(error => {
                //   });
                if (this.roles && this.roles.includes("Call center operator")) {
                  this.$router.push({
                    path: "/callcenter/appraisal"
                  });
                  return;
                }
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });
        }
      },
    },
    mounted() {

    },
  };
</script>



<style lang="scss">
  .customDialog.el-dialog {
    z-index: 0;

    .el-dialog__body {
      padding: 0px 20px;
      color: var(--font-primary) !important;
      font-size: var(--font-medium);
      word-break: break-all;
    }

    .el-dialog__header {
      padding: 10px 20px 10px;
    }
  }

  .mx-datepicker-popup {
    z-index: 3000;
  }
</style>